const ipLocation = require("iplocation");
const publicIp = require("public-ip");

export const geoLocationService = async () => {
  const ipAddr = await publicIp.v4();

  const location = await ipLocation(ipAddr);

  return location.country;
};
